import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { useT } from 'talkr';
import en from './i18n/en.json';
import Markdown from 'react-markdown';

type QuestionAndAnswer = {
    question: string;
    answer: string;
}

export default function FAQAccordion() {
  const {T} = useT();
  return (
    <>
      {Object.values(en.questionsAndAnswers).map(
        (_qa: QuestionAndAnswer, index: number) => (
          <Accordion
            key={index}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              border: "0px solid #cccc",
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              // expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ p: 0 }}
            >
              <Typography variant="h5" color="secondary.main">
                {T(`questionsAndAnswers.q${index + 1}.question`)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <Typography color="secondary.main">
                <Markdown>
                  {T(`questionsAndAnswers.q${index + 1}.answer`)}
                </Markdown>
              </Typography>
            </AccordionDetails>
          </Accordion>
        )
      )}
    </>
  );
}
